export default Object.freeze({
    SERBIA: { id: 1, country_code: 'sr' },
    BOSNIA: { id: 2, country_code: 'ba' },
})
